import React from "react";
import { useRef, useEffect } from "react";
import "./PnLFloorplanDetailsParts.scss";
import { useDispatch, useSelector } from "react-redux";
import {
    BackArrow,
    CompareIcon,
    DownloadIcon,
    EmailIcon,
    FloorplanIcon,
    SiteplanIcon,
} from "./PnLFloorplanIconsSvg";
import PnLFloorplanDetailsCallout from "./PnlFloorplanDetailsCallout.js";
import {
    activeFloorplanToCompare,
    clearCompareFloorplans,
    updateActiveCompareElevation,
    updateActiveElevation,
    updateActiveFloor,
    updateActiveFloorplan,
} from "../../redux/actions/floorplanActions";
import { useHistory } from "react-router-dom";
import {
    addSiteplanActiveFloorplanFilterID,
    clearAllFloorplanFilters,
    updateSiteplanLotActiveIndex,
    updateSiteplanLotOutlines,
} from "../../redux/actions/siteplanActions";
import { emailFloorplans } from "../../redux/actions/floorplanActions.js";

export function PnLElevationSelectButton(props) {
    var dispatch = useDispatch();
    var classes = "elevation-select-button";
    if (props.active) classes += " active";

    function handleClicked(index, compare, side) {
        if (compare) {
            dispatch(updateActiveCompareElevation(index, side));
        } else {
            dispatch(updateActiveElevation(index));
        }
    }

    return (
        <button
            className={classes}
            onClick={() =>
                handleClicked(props.index, props.compare, props.side)
            }
        >
            ELEVATION {props.letter}
        </button>
    );
}

export function PnLMainButton(props) {
    var classes = "PnLMainButton";

    if (!props.icon) classes += " no-icon";
    if (props.white) classes += " white";
    if (props.blue) classes += " blue";

    function handleClicked(e) {
        //the button was clicked and we can run some code here
        if (props.callback) props.callback();
    }

    if (props.download || props.external) {
        return (
            <a
                className={classes}
                role="button"
                href={props.link}
                download={props.download}
                target={props.blank ? "_blank" : ""}
            >
                {props.icon}
                <span className="label">{props.label}</span>
            </a>
        );
    } else {
        return (
            <button className={classes} onClick={(e) => handleClicked(e)}>
                {props.icon}
                <span className="label">{props.label}</span>
            </button>
        );
    }
}

export function PnLElevationInfoContainer(props) {
    var history = useHistory();
    var classes = "PnLElevationInfoContainer";
    var icons = useSelector(
        (state) => state.content.pages.floorplans.floorplan_product_icons
    );
    var isTouchScreen = useSelector((state) => state.utilities.isTouchScreen);
    var dispatch = useDispatch();

    var fpID = props.floorplan.ID;

    if (props.active) {
        classes += " active";
    }

    function comparefloorplansClicked() {
        dispatch(activeFloorplanToCompare());
        history.push("/floorplans/compare");
    }

    function downloadFloorplanClicked() {
        //download might not even need this
    }

    function emailFloorplanClicked() {
        props.emailButtonCB();
    }

    function touchscreenBackButtonClicked() {
        dispatch(updateActiveFloor(0));
        dispatch(updateActiveElevation(-1));
        dispatch(updateActiveFloorplan(-1));
        history.push("/floorplans/list");
    }

    function siteplanClicked() {
        //empty the siteplan filters then add this floorplan as one and then move to the siteplan page
        dispatch(clearAllFloorplanFilters());
        dispatch(updateSiteplanLotActiveIndex(-1));
        dispatch(addSiteplanActiveFloorplanFilterID(props.floorplan.ID));
        dispatch(updateSiteplanLotOutlines());
        history.push("/site-plan");
    }

    function poppymfClicked() {
        history.push("/multi-flex/poppy");
    }

    function inquireButtonClicked() {
        history.push("/contact-us");
    }

    function displayButtons() {
        return (
            <div className="buttons-container">
                {isTouchScreen && (
                    <PnLMainButton
                        icon={<BackArrow />}
                        label="back to floorplans"
                        callback={touchscreenBackButtonClicked}
                    />
                )}
                {!isTouchScreen && props.elevation.downloadable && (
                    <PnLMainButton
                        icon={<DownloadIcon />}
                        label="download floorplan"
                        white
                        blank
                        link={props.elevation.downloadable}
                        download
                    />
                )}
                {!isTouchScreen && (
                    <PnLMainButton
                        label="Inquire today"
                        callback={inquireButtonClicked}
                        blank
                    />
                )}
                {fpID == 4289 && (
                    <PnLMainButton
                        label="discover more"
                        blue
                        callback={poppymfClicked}
                    />
                )}
                <PnLMainButton
                    icon={<EmailIcon />}
                    label="email floorplan"
                    callback={emailFloorplanClicked}
                    white
                />
                <PnLMainButton
                    icon={<CompareIcon />}
                    label="compare floorplans"
                    callback={comparefloorplansClicked}
                    white
                />
                <PnLMainButton
                    icon={<SiteplanIcon />}
                    label="view on siteplan"
                    white
                    callback={siteplanClicked}
                />
            </div>
        );
    }

    function compareButtons() {
        return (
            <div className="buttons-container">
                {!isTouchScreen && (
                    <PnLMainButton
                        icon={<DownloadIcon />}
                        label="downoad floorplan"
                        white
                        blank
                        link={props.elevation.downloadable}
                        download
                    />
                )}
                {/*
        <PnLMainButton
          icon={<EmailIcon />}
          label="email floorplan"
          white
          callback={emailFloorplanClicked}
        />
        <PnLMainButton
          icon={<SiteplanIcon />}
          label="view on siteplan"
          white
          callback={siteplanClicked}
        />
        */}
                <PnLMainButton
                    icon={<SiteplanIcon />}
                    label="change floorplan"
                    callback={() => {
                        dispatch(clearCompareFloorplans(props.side));
                    }}
                    white
                />
            </div>
        );
    }

    return (
        <div className={classes}>
            {false && (
                <div className="label">
                    {props.elevation.elevation_name}{" "}
                    {props.elevation.after_name_text}
                </div>
            )}
            <div className="heading">
                {props.floorplan.post_title} {props.elevation.elevation_name}
            </div>
            <div className="stats-container">
                {Object.keys(props.elevation.stats).map((skey, index) => (
                    <div className={`stat ${skey}`} key={index}>
                        <div className="icon-container">
                            <img src={icons[skey]} className={`icon ${skey}`} />
                        </div>
                        <span className="label">
                            {props.elevation.stats[skey]}
                        </span>
                    </div>
                ))}
            </div>
            {!props.compare && displayButtons()}
            {props.compare && compareButtons()}
        </div>
    );
}

export function PnLFloorplanProductImageDisplay(props) {
    var classes = "PnLFloorplanProductImageDisplay";
    if (props.active) classes += " active";
    if (props.plan.plans.length > 2) classes += " three";

    var fpimg = useRef();
    var fpimgtwo = useRef();
    var outerWrapper = useRef();
    var outerWrappertwo = useRef();
    var calloutcontainer = useRef();
    var calloutcontainertwo = useRef();

    useEffect(() => {
        function updateCustomImageSizing() {
            if (calloutcontainer.current) {
                var imgRect = fpimg.current.getBoundingClientRect();
                var wrapperRect = outerWrapper.current.getBoundingClientRect();
                var marginSpacing = (wrapperRect.width - imgRect.width) / 2;

                //now set the styles for the container
                calloutcontainer.current.style.height = imgRect.height + "px";
                calloutcontainer.current.style.width = imgRect.width + "px";
                calloutcontainer.current.style.left = marginSpacing + "px";
            }

            if (calloutcontainertwo.current) {
                var imgRect = fpimgtwo.current.getBoundingClientRect();
                var wrapperRect =
                    outerWrappertwo.current.getBoundingClientRect();
                var marginSpacing = (wrapperRect.width - imgRect.width) / 2;

                //now set the styles for the container
                calloutcontainertwo.current.style.height =
                    imgRect.height + "px";
                calloutcontainertwo.current.style.width = imgRect.width + "px";
                calloutcontainertwo.current.style.left = marginSpacing + "px";
            }
        }

        window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => {
                    updateCustomImageSizing();
                });
            });
        });
        window.addEventListener("resize", updateCustomImageSizing);

        return () => {
            calloutcontainer.current.style.height = "";
            calloutcontainer.current.style.width = "";
            calloutcontainer.current.style.left = "";

            if (calloutcontainertwo.current) {
                calloutcontainertwo.current.style.height = "";
                calloutcontainertwo.current.style.width = "";
                calloutcontainertwo.current.style.height = "";
            }
            window.removeEventListener("resize", updateCustomImageSizing);
        };
    });
    return (
        <div className={classes}>
            {props.plan.plans.map((plan, pkey) => (
                <div
                    className={`floorplan-wrapper${plan.block_label ? " block" : ""}${plan.callouts.length == 0 ? " hide-co" : ""}`}
                    key={pkey}
                >
                    <label
                        className="label"
                        dangerouslySetInnerHTML={{ __html: plan.label }}
                    />
                    <div
                        className="outer-wrapper"
                        ref={pkey == 0 ? outerWrapper : outerWrappertwo}
                    >
                        <img
                            className="floorplan"
                            src={plan.plan_image}
                            ref={pkey == 0 ? fpimg : fpimgtwo}
                        />
                        <div
                            className="calloutContainer"
                            ref={
                                pkey == 0
                                    ? calloutcontainer
                                    : calloutcontainertwo
                            }
                        >
                            {plan.callouts &&
                                plan.callouts.map((callout, key) => (
                                    <PnLFloorplanDetailsCallout
                                        callout={callout}
                                        index={key}
                                        type={props.type}
                                    />
                                ))}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
